import { initializeApp } from 'firebase/app';
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { getFirestore, collection, addDoc } from 'firebase/firestore';

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Declare variables outside the conditional block
let auth = null;
let db = null;
let testFirestoreWrite = async () => {
    console.warn("testFirebase not initialized");
    return { success: false, error: "Firebase not initialized" };
};
let testFirebaseAuth = async (email, password, isSignUp = false) => {
    console.warn("testFirebase not initialized");
    return { success: false, error: "Firebase not initialized" };
};

// Initialize Firebase
// Check if config values are present before initializing
if (firebaseConfig.apiKey && firebaseConfig.projectId) {
    try {
        const app = initializeApp(firebaseConfig);
        auth = getAuth(app);
        db = getFirestore(app);
        console.log('testFirebase initialized');

        // Re-assign functions if initialization is successful
        testFirestoreWrite = async () => {
            try {
                const docRef = await addDoc(collection(db, "test_collection"), {
                    message: "Hello from Venice Marketplace!",
                    timestamp: new Date()
                });
                console.log("Document written with ID: ", docRef.id);
                return { success: true, docId: docRef.id };
            } catch (error) {
                console.error("Error adding document: ", error);
                return { success: false, error };
            }
        };

        testFirebaseAuth = async (email, password, isSignUp = false) => {
            try {
                let userCredential;
                if (isSignUp) {
                    userCredential = await createUserWithEmailAndPassword(auth, email, password);
                } else {
                    userCredential = await signInWithEmailAndPassword(auth, email, password);
                }
                console.log("Authentication successful:", userCredential.user);
                return { success: true, user: userCredential.user };
            } catch (error) {
                console.error("Authentication error:", error);
                return { success: false, error };
            }
        };
    } catch (initError) {
        console.error('Error initializing Firebase in testFirebase.js:', initError);
        // Keep auth and db as null, functions remain as warnings
    }
} else {
    console.warn('Firebase config missing in testFirebase.js. Skipping initialization.');
}

// Export at the top level
export { auth, db, testFirestoreWrite, testFirebaseAuth }; 